import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Brands } from '../../const/brand';

@Component({
  selector: 'app-brand-image',
  templateUrl: './brand-image.component.html',
  styleUrls: ['./brand-image.component.scss']
})
export class BrandImageComponent implements OnInit {

  @Input() fantasyName: string;

  dataInsurance: any;
  dataProvider: any;
  srcImage: string = '';
  altImage: string = '';
  listBrands: any = Brands;
  isHome: boolean = false;
  showImage: boolean = false;

  constructor(private router: Router) { }

  ngOnInit(): void {
    // console.log('brand-component', this.router.url);
    this.showLogo();
    this.isHome = this.router.url === '/home';
  }

  showLogo(): void {
    if (localStorage.getItem('provider')) {
      this.dataProvider = JSON.parse(localStorage.getItem('provider'));
    }
    this.dataInsurance = JSON.parse(localStorage.getItem('insurance'));
    if(this.dataInsurance) {
      let id = this.dataProvider ? this.dataProvider.id : this.dataInsurance.companyId
      let imageRef = this.getLogo(id);
      this.showImage = !!imageRef.file;
      this.srcImage = `../assets/images/logos/${imageRef.file}`;
      this.altImage = imageRef.alt;
     
    }
  }



  getLogo(idInsurance: string): any {
    let _outBrand = {
      file: '',
      alt: ''
    };
    let _brand = this.listBrands.find(
      x => x.id.toLowerCase() === idInsurance.toLowerCase()
    );
    _outBrand.file = _brand?.file;
    _outBrand.alt = _brand?.alt;
                 
    return _outBrand
  }

}

